$(document).ready(function () {
  const splitBannerDivGreen = document.getElementById('calorie_counter_green');
  function updateTopCountGreen() {
    let startDate = new Date();

    startDate.setHours(0, 0, 0, 0);
    startDate.setMonth(0);
    startDate.setDate(22);
    startDate.setYear(2007);

    let todayDate = new Date();

    let caloriesCount = Math.floor((todayDate.getTime() - startDate.getTime()) / 5000)
    caloriesCount = caloriesCount.toLocaleString("en");
    const replaced = caloriesCount.replaceAll(',', '</span><span>');
    splitBannerDivGreen.innerHTML = '<span>' + replaced + '</span>';
  }

  if (splitBannerDivGreen) {
    updateTopCountGreen();
    setInterval(updateTopCountGreen, 5000);
  }
});